
import React, { useState, useRef, useEffect } from "react";
import "./ChatbotPopup.css";

const Chat = () => {
  const [open, setOpen] = useState(false);
  const [messages, setMessages] = useState([
    { sender: "bot", text: "Hi! Ask me anything 🤖" },
  ]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
  const chatEndRef = useRef(null);

  useEffect(() => {
    if (open && chatEndRef.current) {
      chatEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [messages, open]);

  const handleSend = async () => {
    if (!input.trim()) return;
    const userMessage = { sender: "user", text: input };
    setMessages((prev) => [...prev, userMessage]);
    setLoading(true);
    try {
      const res = await fetch("https://ttf-chatbot.onrender.com/chat", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ query: input }),
      });
      const data = await res.json();
      const botMessage = { sender: "bot", text: data.answer };
      setMessages((prev) => [...prev, botMessage]);
    } catch (error) {
      setMessages((prev) => [
        ...prev,
        { sender: "bot", text: "⚠️ Error connecting to server" },
      ]);
    } finally {
      setLoading(false);
      setInput("");
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") handleSend();
  };

  return (
    <div className="chatbot-popup">
      {open ? (
        <div className="chatbot-container">
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "10px 16px", background: "#0056b3", color: "#fff" }}>
            <span style={{ fontWeight: 600, fontSize: 18 }}>Chatbot</span>
            <button
              aria-label="Close chatbot"
              style={{ background: "none", border: "none", color: "#fff", fontSize: 22, cursor: "pointer" }}
              onClick={() => setOpen(false)}
            >
              ×
            </button>
          </div>
          <div className="chat-window">
            {messages.map((msg, i) => (
              <div
                key={i}
                className={`message ${msg.sender === "user" ? "user" : "bot"}`}
              >
                {msg.text}
              </div>
            ))}
            {loading && <div className="message bot">Typing...</div>}
            <div ref={chatEndRef} />
          </div>
          <div className="input-area">
            <input
              type="text"
              placeholder="Type your question..."
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyPress={handleKeyPress}
              disabled={loading}
            />
            <button onClick={handleSend} disabled={loading || !input.trim()}>
              Send
            </button>
          </div>
        </div>
      ) : (
        <button
          className="chatbot-toggle-btn"
          aria-label="Open chatbot"
          onClick={() => setOpen(true)}
        >
          <span role="img" aria-label="chat">💬</span>
        </button>
      )}
    </div>
  );
};

export default Chat;
